import { API_TAGS } from "../../helpers/constants";
import {
  ICase,
  IGetCasesRequestProps,
  IGetCasesResponseProps,
  IPostCaseCreateRequestProps,
  TPatientNationality,
} from "../../types/Case";
import { api } from "../api";

// Добавляем интерфейс для обновления case
interface IPutCaseUpdateRequestProps {
  id: string;
  patientLastName: string;
  patientFirstName: string;
  patientGender: string;
  patientAge: string | number;
  doctorFullName: string;
  patientNationality?: TPatientNationality | null;
  trgAnalysisType?: number;
}

export const caseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCases: builder.query<IGetCasesResponseProps, IGetCasesRequestProps>({
      query: (params) => ({ url: "cases/all", params }),
      providesTags: () => [API_TAGS.CASE],
    }),
    getCase: builder.query<ICase, string | undefined | number>({
      query: (id: string) => ({ url: `cases/${id}` }),
      providesTags: () => [API_TAGS.CASE],
      transformResponse: async (response: ICase): Promise<ICase> => {
        return {
          ...response,
          patientFullName:
            response.patientFirstName + " " + response.patientLastName,
        };
      },
    }),
    postCaseCreate: builder.mutation<
      { id: number },
      IPostCaseCreateRequestProps
    >({
      query: (credentials) => ({
        url: "cases",
        method: "POST",
        body: credentials,
      }),
      extraOptions: {},
      invalidatesTags: [API_TAGS.CASE],
    }),
    putCaseUpdate: builder.mutation<unknown, IPutCaseUpdateRequestProps>({
      query: ({ id, ...credentials }) => ({
        url: `cases/${id}`,
        method: "PUT",
        body: credentials,
      }),
      extraOptions: {},
      invalidatesTags: [API_TAGS.CASE],
    }),
    deleteCase: builder.mutation<null, number>({
      query: (id) => ({
        url: `cases/${id}`,
        method: "DELETE",
      }),
      extraOptions: {},
      invalidatesTags: [API_TAGS.CASE],
    }),
    postCaseComplaint: builder.mutation<null, { id: number; text: string }>({
      query: ({ id, text }) => ({
        url: `cases/${id}/complaint?text=${text}`,
        method: "POST",
      }),
      extraOptions: {},
      invalidatesTags: [],
    }),
    postCaseTreatmentPlan: builder.mutation<null, { id: number; text: string }>(
      {
        query: ({ id, text }) => ({
          url: `cases/${id}/treatment-plan?text=${text}`,
          method: "POST",
        }),
        extraOptions: {},
        invalidatesTags: [],
      }
    ),
    // GET - получение порядка слайдов
    getSlideOrder: builder.query<string[], string>({
      query: (caseId) => ({ url: `cases/${caseId}/report/slide-order` }),
      transformResponse: (response: { slideOrder: string[] } | string[]) => {
        // Сервер возвращает { slideOrder: [...] }, извлекаем массив
        if (Array.isArray(response)) {
          return response;
        }
        return response?.slideOrder || [];
      },
    }),
    // PUT - сохранение порядка слайдов
    putSlideOrder: builder.mutation<
      void,
      { caseId: string; slideOrder: string[] }
    >({
      query: ({ caseId, slideOrder }) => ({
        url: `cases/${caseId}/report/slide-order`,
        method: "PUT",
        body: { slideOrder },
      }),
    }),
  }),
});

export const {
  useGetCasesQuery,
  useGetCaseQuery,
  usePostCaseCreateMutation,
  usePutCaseUpdateMutation,
  useDeleteCaseMutation,
  usePostCaseComplaintMutation,
  usePostCaseTreatmentPlanMutation,
  useGetSlideOrderQuery,
  usePutSlideOrderMutation,
} = caseApi;
